import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useSelector, useDispatch } from 'react-redux'
import { download_file } from '../../../store/job/jobSlice'
import { formatDateTime } from '../../../helpers/cookies'


const MessageCard = ({ job_id }) => {
  const { job_messages } = useSelector((state) => state.job);
  const dispatch = useDispatch();

  const handleDownloadFile = async (fileKey) => {
    try {
      const action = await dispatch(
        download_file({ job_id: job_id, file_key: fileKey })
      );

      if (download_file.fulfilled.match(action)) {
        const url = action.payload.data.url;
        const link = document.createElement("a");
        link.href = url;
        link.click();
      } else {
        console.error("Failed to download file", action.payload);
      }
    } catch (err) {
      console.error("Download error:", err);
    }
  };

  return (
    job_messages.length > 0 && (
      job_messages.map((message, index) => (
        <Box
          key={index}
          sx={{
            // bgcolor: '#E2EBFF',
            bgcolor: '#F5F5F5',
            py: 1,
            px: 1.5,
            mt: index === 0 ? 0 : 0.5,
            mb: 0.5,
            borderRadius: '10px',
            width: 'fit-content',
            maxWidth: '100%'
          }}
        >
          <Typography variant="subtitle2">
            Note by{" "}
            <strong>
              {message.user.first_name} {message.user.last_name} ({message.user.company.name})
            </strong>{" "}
            - {formatDateTime(message.log_datetime)}
          </Typography>

          <Box>
            {(message.details || message.attachment) && (
              <>
                {message.details && (
                  <Typography variant="subtitle2">
                    {message.details}
                  </Typography>
                )}

                {message.attachment && (
                  <Typography variant="subtitle2">
                    <span
                      onClick={() => handleDownloadFile(message.attachment)}
                      style={{
                        color: '#1204d6ff',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                      }}
                    >
                      {message.attachment.split('/').pop()}
                    </span>
                  </Typography>
                )}
              </>
            )}

            {(!message.details && !message.attachment) && (
              <Typography variant="subtitle2">
                Status: {message.prev_stage?.name || "—"}
                {message.new_stage ? ` → ${message.new_stage.name}` : ""}
              </Typography>
            )}
          </Box>
        </Box>
      ))
    )
  );
}
export default MessageCard;
